import React from 'react';
import { Route } from 'react-router-dom';

// --- Perfil de usuario ---
import UserProfile from './views/Cuenta/PerfilUsuario';

// --- Inscripciones ---
import Inscriptions from './views/Estudiantes/inscriptions';

// --- Dashboards principales (por rol) ---
import Dashboard from './views/Dashboards/Dashboard';
import DashboardDocente from './views/view-docentes/DashboardDocente';
import DashboardEstudiantePc from './views/view-estudiantes-PC/DashboardEstudiantePc';

// --- Administración académica y docentes ---
import Estudiantes from './views/Estudiantes/estudiantes';
import ConfiguracionAcademica from './views/ConfiguracionAcademica/configuracionAcademica';
import GuiaConfiguracion from './views/ConfiguracionAcademica/GuiaConfiguracion';
import Docentes from './views/Docentes/docentes';
import LogrosEstudiantes from './views/Estudiantes/LogrosEstudiantes';
import ProcesosView from './views/ConfiguracionAcademica/procesos';
import PlantillaPreventivaView from './views/Preventivo/planillaPreventiva';
import NotasEstudiantes from './views/Estudiantes/NotasEstudiantes';
import Matriculas from './views/Estudiantes/matricula';
import CalendarioEventos from './views/ConfiguracionAcademica/CalendarioAcademico';
import GestionIncidencias from './views/Disciplinario/IncidenciasVistaGeneral';
import VistaAsignacionTutores from './views/Docentes/Tutores';
import HorarioDocente from './views/view-docentes/HorarioDocente.js';

// --- Cartera / Facturación ---
import BillingConceptsView from './views/Cartera/BillingConcepts';
import BillingView from './views/Cartera/Billing';
import DescuentosEstudiantes from './views/Cartera/descuentoestudiantes';
import EstadoDeCuentas from './views/Cartera/estadodecuentas';
import NewBillingMorosos from './views/Cartera/BillingMorososNew.js';
import BillingReport from './views/Cartera/BillingReport.js';
import BillingMorosos from './views/Cartera/BillingMorosos'; // ⚠ no se usa en ninguna ruta actualmente

// --- Mantenimiento ---
import Build from './components/Building';

// --- Asistencia ---
import AsistenciaView from './views/Asistencia/asistencia';

// --- Administración de usuarios ---
import Usuarios from './views/Administracion/usuarios.js';
import Employees from './views/Administracion/Employees.js'; // ⚠ no se usa en ninguna ruta actualmente

// --- Dashboard estudiante (portal web) ---
import DashboardEstudiante from './views/view-estudiantes/DashboardEstudiante';
import InformacionBasicaEstudiante from './views/view-estudiantes/InformacionBasica';
import ObservacionesAsistencia from './views/view-estudiantes/ObservadorEstudiante';
import NotasEstudiante from './views/view-estudiantes/NotasEstudiante';
import PagosEstudiante from './views/view-estudiantes/PagosEstudiante';
import DashboardReporteEstudiantes from './views/view-estudiantes-PC/ReportesEstudiantesPC';
import NotasEstudiantesPcPreescolar from './views/view-estudiantes-PC/NotasEstudiantesPcPreescolar.js';

// --- Aula virtual, cursos y comunicación ---
import AulaVirtualHome from './views/AulaVirtual/AulaVirtualHome.js';
import ClassroomHome from './views/AulaVirtual/ClassroomHome.js';
import ClassroomManage from './views/AulaVirtual/Classroom/ClassroomManage.js';
import ClassroomView from './views/AulaVirtual/Classroom/ClassroomView.js';
import TaskManage from './views/AulaVirtual/Task/TaskManage.js';
import QuestionBank from './views/AulaVirtual/Exam/QuestionBank.js';
import ExamManage from './views/AulaVirtual/Exam/ExamManage.js';
import ClassroomForumManage from './views/AulaVirtual/Forum/ForumManage.js';
import DashboardPrimaria from './views/AulaVirtual/dashboardprimaria.js';
import ReportesProgreso from './views/AulaVirtual/ReportesProgreso.js';
import PerfilDocente from './views/AulaVirtual/PerfilDocenteConProgreso.js'; // ⚠ no se usa en ninguna ruta actualmente
import PerfilDocenteConProgreso from './views/AulaVirtual/PerfilDocenteConProgreso.js';
import AgendaConEventos from './views/AulaVirtual/AgendaConEventos.js'; // ⚠ no se usa en ninguna ruta actualmente
import Agenda from './views/AulaVirtual/agenda.js';
import Mensajeria from './views/AulaVirtual/Mensajeria.js';
import ForoDiscusion from './views/AulaVirtual/ForoDiscusion.js'; // ⚠ mensajería genérica, no confundir con ClassroomForumManage (foro de un aula)

// --- Portal estudiante PC + reportes ---
import NotasEstudiantePc from './views/view-estudiantes-PC/NotasEstudiantePc';
import PerfilEstudiante from './views/view-estudiantes-PC/perfilEstudiante';
import PagosEstudiantepc from './views/view-estudiantes-PC/pagosEstudiantesPc';
import ObservacionesAsistenciaPC from './views/view-estudiantes-PC/ObservadorEstudiantePc';
import HorarioEstudiantePc from './views/view-estudiantes-PC/horarioestudiante';
import DashboardInasistenciasRepo from './views/Reportes/DashInasistencia';
import DashboardInformesRepo from './views/Reportes/DashInformes';
import DesactivarReportesEstudiantes from './views/Reportes/DesactivarReportesEstudiantes';
import ReportCard from './views/Reportes/AsignaturaPerdida/AsignaturasPerdidasCurso';
import Observador from './views/Reportes/observador.js';
import AgendaEstudiante from './views/view-estudiantes-PC/AgendaEstudiantePC.js';

// --- Blog y anuncios ---
import BlogGestion from './views/w.blog/BlogGestion.js';
import BlogEstudiante from './views/w.blog/BlogEstudiante.js';
import BlogPublico from './views/w.blog/BlogPublico.js';
import GestorAnuncios from './views/Comunicacion/anunciosgestor.js';

// --- No referenciada en routesArray (revisar si sigue siendo necesaria) ---
import Factura from './views/Factura-Gobeapp/view-factura-jassir.js'; // ⚠ no se usa en ninguna ruta actualmente


const routesArray = [

  // --- Perfil de usuario ---
  <Route key="UserProfile" path="/UserProfile" element={<UserProfile />} />,

  // --- Inscripciones ---
  <Route key="inscripciones" path="/inscripciones" element={<Inscriptions />} />,

  // --- Dashboards principales (por rol) ---
  // Nota: las 3 parejas de abajo comparten los mismos paths ("/" y "/dashboard").
  // En React Router, cuando varias rutas coinciden con el mismo path solo una
  // termina renderizándose: revisar si esto es intencional antes de tocarlo.
  <Route key="dashboard" path="/" element={<Dashboard />} />,
  <Route key="dashboard" path="/dashboard" element={<Dashboard />} />,

  <Route key="DashboardDocente" path="/" element={<DashboardDocente />} />,
  <Route key="DashboardDocente" path="/dashboard" element={<DashboardDocente />} />,

  <Route key="DashboardEstudiantePc" path="/" element={<DashboardEstudiantePc />} />,
  <Route key="DashboardEstudiantePc" path="/dashboard" element={<DashboardEstudiantePc />} />,

  // --- Administración académica y docentes ---
  <Route key="students" path="/estudiantes" element={<Estudiantes />} />,
  <Route key="ConfiguracionAcademica" path="/ConfiguracionAcademica" element={<ConfiguracionAcademica/>} />,
  <Route key="GuiaConfiguracion" path="/ConfiguracionAcademica/guia" element={<GuiaConfiguracion/>} />,
  <Route key="teachers" path="/docentes" element={<Docentes />} />,
  <Route key="LogrosEstudiantes" path="/Logros-estudiantes" element={<LogrosEstudiantes/>} />,
  <Route key="Procesos" path="/procesos" element={<ProcesosView/>} />,
  <Route key="EvaluacionPreventiva" path="/evaluacion-preventiva" element={<PlantillaPreventivaView/>} />,
  <Route key="NotasEstudiantes" path="/NotasEstudiantes" element={<NotasEstudiantes/>} />,
  <Route key="matriculas" path="/matriculas" element={<Matriculas />} />,
  <Route key="CalendarioEventos" path="/calendario-academico" element={<CalendarioEventos />} />,
  <Route key="GestionIncidencias" path="/diciplinario/incidencias" element={<GestionIncidencias />} />,
  <Route key="DashboardDocente" path="/dashboard-docente" element={<DashboardDocente />} />,
  <Route key="VistaAsignacionTutores" path="/dashboard-docente/asignaciontutores" element={<VistaAsignacionTutores />} />,
  <Route key="HorarioDocente" path="/dashboard-docente/HorarioAcademico" element={<HorarioDocente/>} />,

  // --- Cartera / Facturación ---
  <Route key="BillingConcepts" path="/cartera/conceptos" element={<BillingConceptsView/>} />,
  <Route key="Billing" path="/cartera/facturacion" element={<BillingView/>} />,
  <Route key="Discounts" path="/cartera/descuentos" element={<DescuentosEstudiantes/>} />,
  <Route key="EstadoCuentas" path="/cartera/estadodecuentas" element={<EstadoDeCuentas/>} />,
  <Route key="Morosos" path="/cartera/morosos" element={<NewBillingMorosos/>} />,
  <Route key="BillingReport" path="/cartera/reporte" element={<BillingReport/>} />,

  // --- Mantenimiento ---
  <Route key="build" path="/mantenimiento" element={<Build />} />,

  // --- Asistencia ---
  <Route key="Asistencia" path="/asistencia" element={<AsistenciaView />} />,

  // --- Administración de usuarios ---
  <Route key="Employees" path="/adminUsers" element={<Usuarios />} />,

  // --- Dashboard estudiante (portal web) ---
  <Route key="DashboardEstudiante" path="/dashboard-estudiante" element={<DashboardEstudiante />} />,
  <Route key="DatosBasicosEstudiante" path="/dashboard-estudiante/datos-basicos-estudiante" element={<InformacionBasicaEstudiante />} />,
  <Route key="ObservacionesAsistencia" path="/dashboard-estudiante/observaciones-estudiante" element={<ObservacionesAsistencia />} />,
  <Route key="CalificacionesEstudiante" path="/dashboard-estudiante/calificaciones-estudiante" element={<NotasEstudiante />} />,
  <Route key="EstadoCuentaEstudiante" path="/dashboard-estudiante/estado-cuenta-estudiante" element={<PagosEstudiante />} />,
  <Route key="ReporteEstudiantePC" path="/reportes-estudiantepc" element={<DashboardReporteEstudiantes />} />,
  <Route key="CalificacionesPreescolar" path="/dashboard-estudiante/calificaciones-estudiante-pre" element={<NotasEstudiantesPcPreescolar />} />,

  // --- Aula virtual, cursos y comunicación ---
  // /aula-virtual y /auladash apuntan a la misma página de inicio del Aula
  // Virtual: se mantienen ambas rutas por si algo externo ya enlaza a
  // cualquiera de las dos.
  <Route key="AulaVirtual" path="/aula-virtual" element={<AulaVirtualHome />} />,
  <Route key="auladash" path="/auladash" element={<AulaVirtualHome />} />,
  <Route key="DashboardPrimaria" path="/dashboard-primaria" element={<DashboardPrimaria />} />,
  <Route key="cursos" path="/cursos" element={<ClassroomHome />} />,
  <Route key="classroom-gestionar" path="/aula/gestionar/:classroomId" element={<ClassroomManage />} />,
  <Route key="classroom-ver" path="/aula/ver/:classroomId" element={<ClassroomView />} />,
  <Route key="classroom-tarea" path="/aula/tarea/:taskId" element={<TaskManage />} />,
  <Route key="classroom-preguntas" path="/aula/:classroomId/preguntas" element={<QuestionBank />} />,
  <Route key="classroom-examen" path="/aula/examen/:examId" element={<ExamManage />} />,
  <Route key="classroom-foro" path="/aula/foro/:forumId" element={<ClassroomForumManage />} />,
  <Route key="reportes-progreso" path="/reportes-progreso" element={<ReportesProgreso />} />,
  <Route key="perfil-docente" path="/perfil-docente" element={<PerfilDocenteConProgreso />} />,
  <Route key="agenda" path="/agenda" element={<Agenda />} />,
  <Route key="mensajeria" path="/mensajeria" element={<Mensajeria />} />,
  <Route key="foro" path="/foro" element={<ForoDiscusion />} />,

  // --- Portal estudiante PC + reportes ---
  <Route key="perfil" path="/dashboard-estudiantepc/perfil" element={<PerfilEstudiante/>} />,
  <Route key="notasDelEstudiante" path="/dashboard-estudiantepc/Notas" element={<NotasEstudiantePc/>} />,
  <Route key="PagosEstudiantepc" path="/dashboard-estudiantepc/estado-de-cuenta" element={<PagosEstudiantepc/>} />,
  <Route key="ObservacionesAsistenciaPC" path="/dashboard-estudiantepc/observador-asistencia" element={<ObservacionesAsistenciaPC/>} />,
  <Route key="HorarioDeClases" path="/dashboard-estudiantepc/horario-de-clases" element={<HorarioEstudiantePc/>} />,
  <Route key="DashInasistencias" path="/informe-inasistencias" element={<DashboardInasistenciasRepo />} />,
  <Route key="DashInformes" path="/informes" element={<DashboardInformesRepo />} />,
  <Route key="DesactivarReportesEstudiantesBoletin" path="/desactivar-reportes" element={<DesactivarReportesEstudiantes/> } />,
  <Route key="DesactivarReportesEstudiantes" path="/Reportes/report-card" element={<ReportCard />} />,
  <Route key="ObservadorView" path="/observador" element={<Observador />} />,
  <Route key="agenda-estudiante" path="/agenda-estudiante" element={<AgendaEstudiante />} />,

  // --- Blog y anuncios ---
  <Route key="blog-gestion" path="/blog-gestion" element={<BlogGestion />} />,
  <Route key="blog-estudiante" path="/blog-estudiante" element={<BlogEstudiante />} />,
  <Route key="blog-publico" path="/blog-publico" element={<BlogPublico />} />,
  <Route path="/gestionar-anuncios" element={<GestorAnuncios />} />,
  <Route path="/gestionar-anuncios" element={<GestorAnuncios />} />

];

export default routesArray;
